export const RESTORE_FOCUS_TIMEOUT = 100
